import {Token} from "@devour/client";

export interface IAuthStore {
    fullToken?: Token;
}

export default {} as IAuthStore;
